import { render, staticRenderFns } from "./JSwitch.vue?vue&type=template&id=9964c5c6&"
import script from "./JSwitch.vue?vue&type=script&lang=js&"
export * from "./JSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9964c5c6')) {
      api.createRecord('9964c5c6', component.options)
    } else {
      api.reload('9964c5c6', component.options)
    }
    module.hot.accept("./JSwitch.vue?vue&type=template&id=9964c5c6&", function () {
      api.rerender('9964c5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JSwitch.vue"
export default component.exports